const IMAGE_EFFECTS = [
  'brightness',
  'exposure',
  'gamma',
  'contrast',
  'saturation',
  'vibrance',
  'warmth',
  'enhance',
  'grayscale',
  'invert',
  'filter',
  'blur',
  'blur-region',
  'sharp',
  'overlay',
  'rotate',
  'flip',
  'mirror',
];

// To make UC images behave correctly when copied to Zola, we add a few "patches" to cdn URLs before saving.
// These 'patches' can cause issues when used as the UC widget source, so this method strips them out.
export const stripUploadcareUrlPatches = uploadcareUrl => {
  if (!uploadcareUrl) return uploadcareUrl;

  return uploadcareUrl
    .replace(/-\/max_icc_size\/0\//, '')
    .replace(/-\/format\/jpeg\//, '')
    .replace(/-\/preview\/(\d+x\d+\/)?/, '');
};

export const patchUploadcareUrl = url => {
  if (!url) return url;

  let newUrl = stripUploadcareUrlPatches(url);

  // Uploadcare currently doesn't strip the original color profile when greyscale is applied.
  // As a fix, they suggested adding `max_icc_size/0` when greyscale is enabled.
  newUrl = newUrl.replace(/-\/grayscale\//, '-/grayscale/-/max_icc_size/0/');

  /**
   * If an image has effects applied, UC requires the "preview" param to be present or the image will break.
   * When that happens, the resulting image (the one copied to Zola) has its max dimension capped at 2048px,
   * which is too small. Our only option is to explicitly specify the jpeg format and a max size of 5000x5000.
   *
   * Source: https://uploadcare.com/docs/transformations/image/#dimensions
   */
  const hasEffectsApplied = IMAGE_EFFECTS.some(effect => newUrl.includes(`-/${effect}`));
  if (hasEffectsApplied) {
    newUrl = newUrl.concat('-/format/jpeg/-/preview/5000x5000/');
  }

  return newUrl;
};

export const patchUploadcareFileUrls = uploadcareFile => ({
  ...uploadcareFile,
  cdnUrl: patchUploadcareUrl(uploadcareFile.cdnUrl),
  cdnUrlModifiers: patchUploadcareUrl(uploadcareFile.cdnUrlModifiers),
});
